import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import PublicationCategories from 'hb-react/shared/components/Publication/PublicationCategories';

const NewsCategories = ({ categories }) => (
  <WrapperStyled>
    <PublicationCategories categories={categories} />
  </WrapperStyled>
);

export default NewsCategories;

const WrapperStyled = styled(Box).attrs({
  display: 'block',
  mb: 4,
})``;
